module.exports = __webpack_public_path__ + "images/category_lp/game_console/main-bg@2x_b3fc0bfc62dbd631ff90bd58e0f17b8b.png";